import { render } from "./people.vue?vue&type=template&id=6ad93548&ts=true"
import script from "./people.vue?vue&type=script&lang=ts"
export * from "./people.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__